export const CUSTOMER_ENVIRONMENT_APPLICATION_STATUS = {
  Enabled: 'Enabled',
  Disabled: 'Disabled',
};

// The column behind this was an ApplicationTrustStatus until it was given its own enum, so a
// response cached before the rename still reads back as the integer 1 or 2, or as Trusted.
const CUSTOMER_ENVIRONMENT_APPLICATION_STATUS_MAPPING = [
  {
    value: CUSTOMER_ENVIRONMENT_APPLICATION_STATUS.Enabled,
    numericValue: 1,
    legacyValue: 'Trusted',
    label: 'Enabled',
    color: '#7DFF92',
  },
  {
    value: CUSTOMER_ENVIRONMENT_APPLICATION_STATUS.Disabled,
    numericValue: 2,
    legacyValue: 'Untrusted',
    label: 'Disabled',
    color: '#FF7B72',
  },
];

const find = status =>
  CUSTOMER_ENVIRONMENT_APPLICATION_STATUS_MAPPING.find(
    item =>
      item.value === status || item.legacyValue === status || item.numericValue === Number(status),
  );

// Enabled is the default everywhere the backend writes one, so an absent or unrecognised value
// reads as enabled rather than as a third state the API cannot produce.
export const getCustomerEnvironmentApplicationStatusValue = status =>
  find(status)?.value ?? CUSTOMER_ENVIRONMENT_APPLICATION_STATUS.Enabled;

export const getCustomerEnvironmentApplicationStatusLabel = status =>
  find(status)?.label ?? 'Enabled';

export const getCustomerEnvironmentApplicationStatusColor = status =>
  find(status)?.color ?? '#7DFF92';

export const getCustomerEnvironmentApplicationStatusOptions = () =>
  CUSTOMER_ENVIRONMENT_APPLICATION_STATUS_MAPPING.map(({ value, label }) => ({ value, label }));

export const isCustomerEnvironmentApplicationEnabled = status =>
  getCustomerEnvironmentApplicationStatusValue(status) ===
  CUSTOMER_ENVIRONMENT_APPLICATION_STATUS.Enabled;
